<template>
  <!-- Title Type Slot --->
  <div
    v-if="type === 'title'"
    :class="['cf-drop-down-menu-item cf-drop-down-menu-item--title', linkClass]"
  >
    <slot />
  </div>

  <!-- Router Link Type Slot --->
  <button
    v-else-if="type === 'routerLink'"
    type="button"
    :class="['cf-drop-down-menu-item cf-drop-down-menu-item--link', linkClass]"
    @click="linkClickHandler"
  >
    <span
      v-if="iconClass"
      :class="['cf-icon', iconClass]"
      :style="iconInlineStyle"
    />

    <div class="cf-flex cf-flex--column cf-flex--align-start cf-flex--gap-6">
      <slot />

      <slot name="additional-content" />
    </div>
  </button>

  <!-- Button Type Slot -->
  <button
    v-else-if="type === 'button'"
    type="button"
    :class="['cf-drop-down-menu-item cf-drop-down-menu-item--link', linkClass]"
    @click="buttonClickHandler"
  >
    <span
      v-if="iconClass"
      :class="['cf-icon', iconClass]"
      :style="iconInlineStyle"
    />

    <div class="cf-flex cf-flex--column cf-flex--align-start cf-flex--gap-6">
      <slot />

      <slot name="additional-content" />
    </div>
  </button>

  <!-- Link Type Slot -->
  <a
    v-else-if="type === 'link' && href"
    :href="href"
    :class="['cf-drop-down-menu-item cf-drop-down-menu-item--link', linkClass]"
    :target="hrefTarget"
  >
    <slot />
  </a>

  <div
    v-else
    :class="['cf-drop-down-menu-item cf-drop-down-menu-item--link', linkClass]"
  >
    <slot />
  </div>
</template>


<script>
  export default {
    name: 'DropDownMenuItem',

    inject: ['provider_closeDropDownMenu'],

    props: {
      type: {
        type: String,
        default: ''
      },

      linkTo: {
        type: Object,
        default() {
          return {};
        }
      },

      href: {
        type: String,
        default: ''
      },

      hrefTarget: {
        type: String,
        default: '_blank'
      },

      linkClass: {
        type: String,
        default: ''
      },

      iconClass: {
        type: String,
        default: ''
      },

      iconInlineStyle: {
        type: String,
        default: ''
      }
    },

    emits: ['click'],

    computed: {
      routerToLink() {
        const hasParams = Object.keys(this.linkTo.params || []).length > 0;

        return hasParams ? this.linkTo : Object.assign(this.linkTo, { merchantId: this.$route.params.merchantId });
      }
    },

    methods: {
      linkClickHandler() {
        this.provider_closeDropDownMenu();

        const hasParams = Object.keys(this.linkTo.params || []).length > 0;

        const routerLink = hasParams
          ? this.linkTo
          : Object.assign(this.linkTo, { merchantId: this.$route.params.merchantId });

        this.$router.push(routerLink);
      },

      buttonClickHandler() {
        this.provider_closeDropDownMenu();

        this.$emit('click');
      }
    }
  };
</script>
